var map = {
	"./template.bet575": 679,
	"./template.bet575.tsx": 679,
	"./template.bet777": 413,
	"./template.bet777.tsx": 413,
	"./template.betbetbet": 680,
	"./template.betbetbet.tsx": 680,
	"./template.betgalaxy": 1744,
	"./template.betgalaxy.tsx": 1744,
	"./template.betprofessor": 681,
	"./template.betprofessor.tsx": 681,
	"./template.betroyale": 682,
	"./template.betroyale.tsx": 682,
	"./template.betstride": 683,
	"./template.betstride.tsx": 683,
	"./template.buffalobet": 684,
	"./template.buffalobet.tsx": 684,
	"./template.chromabet": 685,
	"./template.chromabet.tsx": 685,
	"./template.default": 702,
	"./template.default.tsx": 702,
	"./template.epicodds": 686,
	"./template.epicodds.tsx": 686,
	"./template.fiestabet": 687,
	"./template.fiestabet.tsx": 687,
	"./template.forsport": 688,
	"./template.forsport.tsx": 688,
	"./template.gigabet": 689,
	"./template.gigabet.tsx": 689,
	"./template.goldenbet888": 690,
	"./template.goldenbet888.tsx": 690,
	"./template.goldenrush": 691,
	"./template.goldenrush.tsx": 691,
	"./template.hyperbet": 692,
	"./template.hyperbet.tsx": 692,
	"./template.juicybet": 693,
	"./template.juicybet.tsx": 693,
	"./template.junglebet": 722,
	"./template.junglebet.tsx": 722,
	"./template.magnumbet": 694,
	"./template.magnumbet.tsx": 694,
	"./template.oldgill": 695,
	"./template.oldgill.tsx": 695,
	"./template.puntcity": 696,
	"./template.puntcity.tsx": 696,
	"./template.puntgenie": 697,
	"./template.puntgenie.tsx": 697,
	"./template.pyramidbet": 698,
	"./template.pyramidbet.tsx": 698,
	"./template.questbet": 699,
	"./template.questbet.tsx": 699,
	"./template.slambet": 700,
	"./template.slambet.tsx": 700,
	"./template.sterlingparker": 701,
	"./template.sterlingparker.tsx": 701,
	"./template.sugarcastle": 723,
	"./template.sugarcastle.tsx": 723,
	"./template.templebet": 1745,
	"./template.templebet.tsx": 1745,
	"./template.titanbet": 703,
	"./template.titanbet.tsx": 703,
	"./template.ts": 992,
	"./template.vikingbet": 704,
	"./template.vikingbet.tsx": 704,
	"./template.volcanobet": 705,
	"./template.volcanobet.tsx": 705,
	"./template.wellbet": 706,
	"./template.wellbet.tsx": 706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2479;